export default __webpack_public_path__ + "static/media/Avatar-23-noback.b96abdc6.png";